const filePng = `
    <svg width="20px" height="24px" viewBox="0 0 20 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>file-format-png-1</title>
    <desc>Created with Sketch.</desc>
    <g id="Settings-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-Settings--PS--Greenscreen---edit" transform="translate(-637.000000, -626.000000)">
            <g id="greenscreen" transform="translate(309.000000, 481.000000)">
                <g id="Group-11" transform="translate(26.000000, 88.000000)">
                    <g id="file-format-png-1" transform="translate(302.000000, 57.000000)">
                        <g id="Outline_Icons" stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round">
                            <g id="Group">
                                <polyline id="Path" points="8.5 18.5 8.5 13.5 11.5 18.5 11.5 13.5"></polyline>
                                <path d="M16.359,14.5 C16.191,13.754 15.812,13.5 15,13.5 C13.742,13.5 13.5,14.535 13.5,16 C13.5,17.462 13.742,18.5 15,18.5 C16.048,18.5 16.42,17.622 16.5,16.5 L15,16.5" id="Path"></path>
                                <g id="Path">
                                    <polygon points="19.5 23.5 0.5 23.5 0.5 0.5 13.5 0.5 19.5 6.5"></polygon>
                                    <polyline points="13.5 0.5 13.5 6.5 19.5 6.5"></polyline>
                                </g>
                                <path d="M3.5,18.5 L3.5,13.5 L4.75,13.5 C5.44,13.5 6,14.06 6,14.75 C6,15.44 5.44,16 4.75,16 L3.5,16" id="Path"></path>
                            </g>
                        </g>
                        <g id="Invisible_Shape">
                            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>

    `;

export default filePng;
